// Picks the father's name out of a digilocker/v2/fetch response.
// father_name wins; guardian_name is the fallback; '' means the user has to type it.
// Each candidate is trimmed first, so a whitespace-only father_name still falls
// through to guardian_name instead of resolving to a blank field.
//
// isAllowed lets the caller reject a candidate the form cannot accept (the
// government database stores names like "RAJESH (LATE)" or "S/O RAM-KUMAR").
// A rejected candidate is skipped exactly as if it were absent, so a malformed
// father_name still falls through to a clean guardian_name. It lives as a
// parameter rather than an import so this util stays dependency-free.
export const resolveFatherName = (data, isAllowed = () => true) =>
  [data?.father_name, data?.guardian_name]
    .map((candidate) => (candidate || '').trim())
    .find((candidate) => candidate && isAllowed(candidate)) || '';

export default resolveFatherName;
